import { MapPin } from "lucide-react";

export default function Coverage() {
  return (
    <section id="coverage" className="py-14 bg-[#F9FBFF]">
      <div className="container-max">
        <div className="card p-6 md:p-8 flex flex-col md:flex-row items-center gap-6">
          <div className="w-12 h-12 rounded-full bg-brand-blue/10 text-brand-blue flex items-center justify-center">
            <MapPin />
          </div>
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-extrabold">Coverage</h3>
            <p className="text-brand-blue/70 text-sm mt-1">
              Serving Dakor, Gujarat and nearby areas. Contact us to confirm availability for your address.
            </p>
          </div>
          <a href="#contact" className="btn btn-primary">Check Availability</a>
        </div>
      </div>
    </section>
  );
}

